<template>
  <div 
    class="file-box"
    :class="[
      !file.is_available ? 'not-available' : ''
    ]"
    v-if="!file.should_delete"
    >
    <div class="left-side">
      <div class="icon">
        <!-- <img src="/images/icons/file-green.svg" /> -->
        <i class="fal fa-file"></i>
      </div>
      <div class="file-info">
        <div class="file-name">
          {{ truncateIfBig(file.file_name) }}
        </div>
        <div class="file-size">
          {{ humanFileSize(file.size) }} 
        </div>
      </div>
    </div>
    <div class="right-side">
      <strong v-if="!file.is_available">
        Processing
      </strong>
      <span v-else>
        Uploaded on {{ new Date(file.created_at).toLocaleDateString() }}
      </span>
    </div>

    <a :href="`/download/${base64Encode(file.id)}`" v-if="file.is_available && canDownload" target="_blank" class="link"></a>
  </div>
</template>

<script>

export default {
  props: [
    'file',
    'admin',
    'canDownload'
  ],
  methods: {
    humanFileSize(payload) {
      let fileSize = ''
      let size = parseInt(payload)

      if (size >= 1073741824) {
        fileSize = this.round(size / 1024 / 1024 / 1024, 1) + ' GB'
      } else if (size >= 1048576) {
        fileSize = this.round(size / 1024 / 1024, 1) + ' MB'
      } else if(size >= 1024) {
        fileSize = this.round(size / 1024, 1) + ' KB'
      } else {
        fileSize = size + ' bytes'
      }
      return fileSize
    },
    round(value, precision) {
      let multiplier = Math.pow(10, precision || 0);
      return Math.round(value * multiplier) / multiplier;
    },
    base64Encode(string){
      let value = String(string)
      if (process.client) {
        return window.btoa(unescape(encodeURIComponent(value)))
      } else {
        return Buffer.from(value, 'ascii').toString('base64')
      }
    },
    truncateIfBig(string){
      if(string.length > 30){
        let splitString = string.split('.')
        let fileExt = splitString[splitString.length - 1]

        return string.slice(0, 30)+' ... .'+fileExt
      }else{
        return string
      }
    }
  },
  computed: {
    
  }
}

</script>

<style scoped lang="sass">


.file-box
  width: 100%
  background-color: #E0F5DD
  border-radius: 8px
  padding: 25px 30px
  display: flex
  align-items: flex-end
  justify-content: space-between
  color: #3E8732
  gap: 20px
  position: relative

  @media (max-width: 768px)
    flex-direction: column
    padding: 15px 20px
    gap: 10px

  &.not-available
    background-color: #EDC7B7
    color: #602E2B

  .link
    position: absolute
    top: 0
    left: 0
    right: 0
    bottom: 0
    display: block
    z-index: 10

  .left-side
    display: flex
    align-items: center
    gap: 20px

    @media (max-width: 768px)
      flex-direction: row
      width: 100%
      gap: 12px

    .icon
      width: 30px
      height: 40px
      display: flex
      align-items: center

      img
        max-height: 100%
        height: auto
        width: 100%

      .fal
        font-size: 40px

      @media (max-width: 768px)
        width: 20px
        height: 30px

        .fal
          font-size: 30px

    .file-info
      display: flex
      flex-direction: column

      @media (max-width: 768px)
        font-size: 12px

      .file-size
        font-weight: 700
        text-align: left

      .file-name
        width: 100%
        white-space: nowrap
        overflow: hidden
        text-overflow: ellipsis

        @media (max-width: 768px)
          max-width: 60vw

  .right-side
    font-size: 14px
    font-family: 'Roboto Condensed', sans-serif

    @media (max-width: 768px)
      width: 100%

</style>